(function(){
  'use strict';

  function pairCount(value){
    var m=String(value||'').toLowerCase().match(/(\d+)/);
    return m?parseInt(m[1],10):1;
  }

  function money(cents,currency,locale){
    var lang=String(locale||document.documentElement.lang||'fr').toLowerCase();
    var l=lang.indexOf('en')===0?'en-GB':(lang.indexOf('es')===0?'es-ES':'fr-FR');
    try{
      return new Intl.NumberFormat(l,{
        style:'currency',
        currency:currency||'EUR',
        minimumFractionDigits:cents%100===0?0:2,
        maximumFractionDigits:2
      }).format(cents/100);
    }catch(e){
      return (cents/100).toFixed(2)+(currency||'EUR');
    }
  }

  function findPlan(tier){
    if(!tier||!tier.variant||!tier.variant.plans||!tier.variant.plans.length)return null;
    return tier.variant.plans[0];
  }

  function init(root){
    if(!root||root.dataset.patchsV4Ready==='true')return;
    var node=root.querySelector('[data-patchs-v4-data]');
    if(!node)return;

    var data;
    try{data=JSON.parse(node.textContent);}catch(e){return;}

    var targets=(root.dataset.targets||'1,5,10,15').split(',').map(function(value){return parseInt(value,10);}).filter(function(value){return !isNaN(value);});
    var labels={
      1:root.dataset.label1||'Découverte',
      5:root.dataset.label5||'Le geste régulier',
      10:root.dataset.label10||'Le plus populaire',
      15:root.dataset.label15||'Meilleure valeur'
    };
    var popular=parseInt(root.dataset.popular||'10',10);
    var best=parseInt(root.dataset.best||'15',10);
    var defaultCount=parseInt(root.dataset.defaultCount||'5',10);
    var threshold=parseInt(root.dataset.shippingThreshold||'5000',10);
    var locale=root.dataset.locale||'fr';
    var pairSingular=root.dataset.i18nPairSingular||'paire';
    var pairPlural=root.dataset.i18nPairPlural||'paires';
    var perPairLabel=root.dataset.i18nPerPair||'/ paire';
    var variantMissing=root.dataset.i18nVariantMissing||'Variante à créer dans Shopify';
    var purchaseOnce=root.dataset.i18nPurchaseOnce||'Achat ponctuel';
    var regularDelivery=root.dataset.i18nRegularDelivery||'Livraison régulière';
    var subscriptionNote=root.dataset.i18nSubscriptionNote||'Livraison régulière · modifiable, en pause ou résiliable selon les conditions de l’abonnement.';
    var onetimeNote=root.dataset.i18nOnetimeNote||'Achat ponctuel · Sans engagement.';
    var addLabel=root.dataset.i18nAdd||'AJOUTER';
    var unavailableLabel=root.dataset.i18nUnavailable||'INDISPONIBLE';
    var shippingFreeFrom=root.dataset.i18nShippingFreeFrom||'Livraison offerte dès';
    var shippingIncluded=root.dataset.i18nShippingIncluded||'incluse avec cette option';
    var shippingRemaining=root.dataset.i18nShippingRemaining||'plus que';

    var variants=(data.variants||[]).map(function(v){
      return {count:pairCount(v.title),variant:v};
    });
    function tierFor(count){
      for(var i=0;i<variants.length;i+=1){
        if(variants[i].count===count)return variants[i];
      }
      return null;
    }

    var base=tierFor(1)||variants[0]||null;
    if(!base){root.hidden=true;return;}
    var baseRegular=(base.variant.compareAtPrice&&base.variant.compareAtPrice>base.variant.price)
      ?base.variant.compareAtPrice:base.variant.price;

    var state={count:defaultCount,mode:'onetime'};
    var defaultTier=tierFor(defaultCount);
    if(!defaultTier||!defaultTier.variant.available){
      for(var d=0;d<targets.length;d+=1){
        var t=tierFor(targets[d]);
        if(t&&t.variant.available){state.count=t.count;break;}
      }
    }
    if(!findPlan(tierFor(state.count)))state.mode='onetime';

    var tiersEl=root.querySelector('[data-patchs-v4-tiers]');
    var modesEl=root.querySelector('[data-patchs-v4-modes]');
    var modeNote=root.querySelector('[data-patchs-v4-mode-note]');
    var variantInput=root.querySelector('[data-patchs-v4-variant]');
    var planInput=root.querySelector('[data-patchs-v4-plan]');
    var cta=root.querySelector('[data-patchs-v4-cta]');
    var ctaText=root.querySelector('[data-patchs-v4-cta-text]');
    var shipping=root.querySelector('[data-patchs-v4-shipping]');
    var sticky=root.parentElement ? root.parentElement.querySelector('[data-patchs-v4-sticky]') : null;
    if(!sticky)sticky=document.querySelector('[data-patchs-v4-sticky][data-for="'+root.id+'"]');
    var stickyTitle=sticky&&sticky.querySelector('[data-patchs-v4-sticky-title]');
    var stickyPrice=sticky&&sticky.querySelector('[data-patchs-v4-sticky-price]');
    var stickyButton=sticky&&sticky.querySelector('[data-patchs-v4-sticky-button]');

    function selected(){return tierFor(state.count);}
    function plan(){return state.mode==='subscription'?findPlan(selected()):null;}
    function actualPrice(tier){
      var p=state.mode==='subscription'?findPlan(tier):null;
      return p?p.price:tier.variant.price;
    }
    function regularPackPrice(tier){
      return tier.variant.compareAtPrice&&tier.variant.compareAtPrice>tier.variant.price
        ?tier.variant.compareAtPrice:tier.variant.price;
    }
    function unitBenchmark(count){return Math.round(baseRegular*count);}
    function volumeSaving(tier){
      return Math.max(0,unitBenchmark(tier.count)-regularPackPrice(tier));
    }
    function volumePct(tier){
      var b=unitBenchmark(tier.count),s=volumeSaving(tier);
      return b>0&&s>0?Math.round(s/b*100):0;
    }
    function launchSaving(tier){
      return tier.variant.compareAtPrice&&tier.variant.compareAtPrice>tier.variant.price
        ?tier.variant.compareAtPrice-tier.variant.price:0;
    }
    function launchPct(tier){
      var s=launchSaving(tier),c=tier.variant.compareAtPrice||0;
      return c>0&&s>0?Math.round(s/c*100):0;
    }

    function renderTiers(){
      var unitTier=tierFor(1);
      var unitReference=unitTier
        ? (unitTier.variant.compareAtPrice && unitTier.variant.compareAtPrice > unitTier.variant.price
            ? unitTier.variant.compareAtPrice
            : unitTier.variant.price)
        : 0;

      tiersEl.innerHTML=targets.map(function(count){
        var tier=tierFor(count);
        var missing=!tier;
        var disabled=missing||!tier.variant.available;
        var selectedClass=!missing&&state.count===count?' is-selected':'';
        var badge=(count===popular||count===best);
        var label=labels[count]||'';
        var commerce='';

        if(!missing){
          var current=actualPrice(tier);
          var perPair=Math.round(current/count);
          var unitBenchmark=unitReference>0 ? unitReference*count : 0;

          commerce=[
            '<span class="patchs-offer-v4__price">',
              money(current,data.currency,locale),
              (unitBenchmark>current)
                ?'<span class="patchs-offer-v4__compare">'+money(unitBenchmark,data.currency,locale)+'</span>':'',
            '</span>',
            count>1
              ?'<span class="patchs-offer-v4__unit">'+money(perPair,data.currency,locale)+' '+perPairLabel+'</span>'
              :''
          ].join('');
        }

        return [
          '<button type="button" class="patchs-offer-v4__tier',selectedClass,'" data-count="',count,'"',
          disabled?' disabled aria-disabled="true"':'',
          ' aria-pressed="',(!missing&&state.count===count?'true':'false'),'">',
          badge?'<span class="patchs-offer-v4__badge">'+label+'</span>':'<span class="patchs-offer-v4__position">'+label+'</span>',
          '<span class="patchs-offer-v4__count">',count,' ',count===1?pairSingular.toUpperCase():pairPlural.toUpperCase(),'</span>',
          missing?'<span class="patchs-offer-v4__missing">'+variantMissing+'</span>':'<span class="patchs-offer-v4__commerce">'+commerce+'</span>',
          '</button>'
        ].join('');
      }).join('');

      Array.prototype.forEach.call(tiersEl.querySelectorAll('[data-count]'),function(btn){
        btn.addEventListener('click',function(){
          if(btn.disabled)return;
          state.count=parseInt(btn.dataset.count,10);
          if(state.mode==='subscription'&&!findPlan(selected()))state.mode='onetime';
          render();
        });
      });
    }

    function anyPlans(){
      for(var i=0;i<variants.length;i+=1){
        if(findPlan(variants[i]))return true;
      }
      return false;
    }

    function renderModes(){
      if(!modesEl)return;
      if(!anyPlans()){
        modesEl.hidden=true;
        if(modeNote)modeNote.hidden=true;
        state.mode='onetime';
        return;
      }
      modesEl.hidden=false;
      if(modeNote)modeNote.hidden=false;
      var tier=selected();
      var p=findPlan(tier);
      var subPct=0;
      if(p&&tier.variant.price>p.price){
        subPct=Math.round((tier.variant.price-p.price)/tier.variant.price*100);
      }
      modesEl.innerHTML=[
        '<button type="button" class="patchs-offer-v4__mode',state.mode==='onetime'?' is-selected':'','" data-mode="onetime">'+purchaseOnce+'</button>',
        '<button type="button" class="patchs-offer-v4__mode',state.mode==='subscription'?' is-selected':'','" data-mode="subscription"',p?'':' disabled','>'+regularDelivery,subPct?' <strong>−'+subPct+'%</strong>':'','</button>'
      ].join('');
      Array.prototype.forEach.call(modesEl.querySelectorAll('[data-mode]'),function(btn){
        btn.addEventListener('click',function(){
          if(btn.disabled)return;
          state.mode=btn.dataset.mode;
          render();
        });
      });
      if(modeNote){
        modeNote.textContent=state.mode==='subscription'
          ?subscriptionNote
          :onetimeNote;
      }
    }

    function renderForm(){
      var tier=selected();
      if(!tier)return;
      var p=plan();
      var current=actualPrice(tier);
      var compare=tier.variant.compareAtPrice&&tier.variant.compareAtPrice>tier.variant.price
        ?tier.variant.compareAtPrice:0;
      variantInput.value=tier.variant.id;
      variantInput.dispatchEvent(new Event('change',{bubbles:true}));

      if(p){
        planInput.disabled=false;
        planInput.value=p.id;
      }else{
        planInput.disabled=true;
        planInput.value='';
      }

      cta.disabled=!tier.variant.available;
      if(tier.variant.available){
        var label=addLabel+' '+tier.count+' '+(tier.count===1?pairSingular.toUpperCase():pairPlural.toUpperCase())+' · '+money(current,data.currency,locale);
        ctaText.innerHTML='<span>'+label+'</span>'+(compare?'<span class="patchs-offer-v4__cta-compare">'+money(compare,data.currency,locale)+'</span>':'');
      }else{
        ctaText.textContent=unavailableLabel;
      }

      if(shipping){
        shipping.textContent=current>=threshold
          ?shippingFreeFrom+' '+money(threshold,data.currency,locale)+' · '+shippingIncluded
          :shippingFreeFrom+' '+money(threshold,data.currency,locale)+' · '+shippingRemaining+' '+money(threshold-current,data.currency,locale);
      }

      if(stickyTitle)stickyTitle.textContent=tier.count+' '+(tier.count===1?pairSingular:pairPlural);
      if(stickyPrice){
        var per=Math.round(current/tier.count);
        stickyPrice.innerHTML=(tier.count>1?money(per,data.currency,locale)+' '+perPairLabel+' · ':'')+money(current,data.currency,locale)+(compare?' · <s>'+money(compare,data.currency,locale)+'</s>':'');
      }
    }

    function render(){
      renderTiers();
      renderModes();
      renderForm();
    }

    if(stickyButton){
      stickyButton.addEventListener('click',function(){
        if(!cta.disabled)cta.click();
      });
    }

    /* Same UX intent as Régénère, with an extra passive scroll guard so the
       bar cannot remain hidden when CTA starts below the fold. */
    if(sticky&&cta){
      var ctaVisible=true;
      function updateSticky(){
        sticky.hidden=ctaVisible||window.scrollY<300;
      }
      if('IntersectionObserver'in window){
        var observer=new IntersectionObserver(function(entries){
          ctaVisible=!!(entries[0]&&entries[0].isIntersecting);
          updateSticky();
        },{threshold:.05});
        observer.observe(cta);
      }
      window.addEventListener('scroll',updateSticky,{passive:true});
      updateSticky();
    }

    render();
    root.dataset.patchsV4Ready='true';
  }

  function boot(scope){
    Array.prototype.forEach.call((scope||document).querySelectorAll('[data-patchs-offer-v4]'),init);
  }

  function bootTimeline(scope){
    Array.prototype.forEach.call((scope||document).querySelectorAll('[data-patchs-v4-timeline]'), function(section){
      if(section.dataset.timelineReady==='true') return;
      var steps = Array.prototype.slice.call(section.querySelectorAll('[data-patchs-v4-step]'));
      if(!steps.length){ section.dataset.timelineReady='true'; return; }
      if('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){ if(entry.isIntersecting){ entry.target.classList.add('is-visible'); } });
          var visible = steps.filter(function(step){
            var rect = step.getBoundingClientRect();
            return rect.top < window.innerHeight * 0.55 && rect.bottom > window.innerHeight * 0.2;
          });
          steps.forEach(function(step){ step.classList.remove('is-active'); });
          if(visible[0]) visible[0].classList.add('is-active');
        }, {threshold:[0.15,0.5,0.8]});
        steps.forEach(function(step){ io.observe(step); });
      } else {
        steps.forEach(function(step, index){
          step.classList.add('is-visible');
          if(index===0) step.classList.add('is-active');
        });
      }
      function syncActive(){
        var current = null;
        steps.forEach(function(step){
          var rect = step.getBoundingClientRect();
          if(rect.top < window.innerHeight * 0.5 && rect.bottom > window.innerHeight * 0.22){ current = step; }
        });
        if(current){ steps.forEach(function(step){ step.classList.toggle('is-active', step === current); }); }
      }
      window.addEventListener('scroll', syncActive, {passive:true});
      syncActive();
      section.dataset.timelineReady='true';
    });
  }

  function bootAll(scope){
    boot(scope);
    bootTimeline(scope);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){bootAll(document);});
  }else{
    bootAll(document);
  }

  document.addEventListener('shopify:section:load',function(e){
    bootAll(e.target);
  });
})();